var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCommonLanguage = function SvgIcnCommonLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C12.3582 16.5 15.201 14.2928 16.1566 11.25M9 16.5C5.64177 16.5 2.79905 14.2928 1.84335 11.25M9 16.5C9 16.5 11.0279 14.4721 11.7491 11.25M9 16.5C9 16.5 6.97212 14.4721 6.25088 11.25M9 1.5C5.64177 1.5 2.79905 3.70717 1.84335 6.75M9 1.5C12.3582 1.5 15.201 3.70717 16.1566 6.75M9 1.5C9 1.5 6.97212 3.52787 6.25088 6.75M9 1.5C9 1.5 11.0279 3.52787 11.7491 6.75M1.84335 6.75C1.62027 7.46028 1.5 8.2161 1.5 9C1.5 9.7839 1.62027 10.5397 1.84335 11.25M1.84335 6.75H6.25088M16.1566 6.75C16.3797 7.46028 16.5 8.2161 16.5 9C16.5 9.7839 16.3797 10.5397 16.1566 11.25M16.1566 6.75H11.7491M16.1566 11.25H11.7491M1.84335 11.25H6.25088M6.25088 6.75C6.09487 7.44694 6 8.19975 6 9C6 9.80025 6.09487 10.5531 6.25088 11.25M6.25088 6.75H11.7491M11.7491 6.75C11.9051 7.44694 12 8.19975 12 9C12 9.80025 11.9051 10.5531 11.7491 11.25M11.7491 11.25L6.25088 11.25",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCommonLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-common-language.8f2009c6.svg";
export { ForwardRef as ReactComponent };